module.exports = __webpack_public_path__ + "assets/1ed6cdb5a77e3f2a5925e5e360b085fc.mp4";